module.exports = __webpack_public_path__ + "img/toChangeVideo.28a01a4e.png";